export const OVERPLAYED = 'overplayed';
export const HEAVILY_OVERPLAYED = 'heavilyoverplayed';
export const UNDERPLAYED = 'underplayed';
export const HEAVILY_UNDERPLAYED = 'heavilyunderplayed';
export const NEUTRAL = 'neutral';

// Columns in lookup table (diff is difference between ATG bet distribution percentage and own percentage)
// 0 : Atg max bet percentage to use the row
// 1 : Min diff for underplayed
// 2 : Min diff for heavily underplayed
// 3 : Min diff for overplayed
// 4 : Min diff for heavily overplayed
export const KELLYLOOKUPTABLE = [
  [0.5, 0.3, 1.5, 0.2, 0.3],
  [1, 0.4, 2, 0.4, 0.5],
  [2, 0.5, 2.5, 0.5, 0.8],
  [3, 0.7, 3, 0.7, 1.5],
  [4, 1, 3.5, 1, 2],
  [5, 1, 4, 1, 2.5],
  [6, 1.5, 4, 1.5, 2.5],
  [7, 1.5, 4, 1.5, 3],
  [8, 1.5, 5, 1.5, 3],
  [9, 1.5, 5, 1.5, 3.5],
  [10, 1.5, 5, 1.5, 3.5],
  [14, 2, 6, 2, 4],
  [22, 2, 6, 2, 5],
  [31, 2, 6, 2, 6],
  [41, 3, 6, 3, 6],
  [51, 3, 6, 3, 7],
  [61, 3, 6, 4, 8],
  [71, 3, 5, 4, 9],
  [81, 3, 5, 4, 10],
  [101, 3, 4, 4, 12],
];
